var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightFormIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 51,
    viewBox: "0 0 37 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8306 8.11805C26.8315 7.17783 26.2548 6.32829 25.3669 5.96099L23.6465 5.24747C22.1485 4.62737 21.1764 3.19483 21.1783 1.60932C21.1769 0.720851 20.4385 0.000915948 19.5266 0H17.4734C16.5615 0.000915948 15.8226 0.720851 15.8217 1.60932C15.8236 3.19483 14.851 4.62737 13.3535 5.24747L11.6327 5.96099C10.7443 6.32829 10.168 7.17783 10.1689 8.11805V9.85698H26.8306V8.11805Z",
    fill: "url(#paint0_linear_5532_20536)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3901 8.88928H29.2372V11.0298C29.2372 11.6774 28.6985 12.2023 28.0339 12.2023H8.96609C8.30145 12.2023 7.76278 11.6774 7.76278 11.0298V8.88928H3.60994C1.61695 8.89157 0.00235021 10.4647 0 12.4065V47.4828C0.00235021 49.4246 1.61695 50.9977 3.60994 51H33.3901C35.383 50.9977 36.9981 49.4246 37 47.4828V12.4065C36.9981 10.4647 35.383 8.89157 33.3901 8.88928ZM5.78812 22.0263H16.2969C16.9615 22.0263 17.5002 22.5511 17.5002 23.1987C17.5002 23.8463 16.9615 24.3711 16.2969 24.3711H5.78812C5.12348 24.3711 4.58481 23.8463 4.58481 23.1987C4.58481 22.5511 5.12348 22.0263 5.78812 22.0263ZM31.2119 42.1977H5.78812C5.12348 42.1977 4.58481 41.6729 4.58481 41.0253C4.58481 40.3778 5.12348 39.8529 5.78812 39.8529H31.2119C31.8765 39.8529 32.4152 40.3778 32.4152 41.0253C32.4152 41.6729 31.8765 42.1977 31.2119 42.1977ZM31.2119 33.5942H5.78812C5.12348 33.5942 4.58481 33.0694 4.58481 32.4218C4.58481 31.7742 5.12348 31.2494 5.78812 31.2494H31.2119C31.8765 31.2494 32.4152 31.7742 32.4152 32.4218C32.4152 33.0694 31.8765 33.5942 31.2119 33.5942Z",
    fill: "url(#paint1_linear_5532_20536)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5532_20536",
    x1: -6.21806,
    y1: 105.825,
    x2: -49.6063,
    y2: 79.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5532_20536",
    x1: -6.21806,
    y1: 105.825,
    x2: -49.6063,
    y2: 79.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightFormIcon);
export default __webpack_public_path__ + "static/media/insight_form_icon.5d186cd2ca6f521cf952c13abc59bca7.svg";
export { ForwardRef as ReactComponent };